import api from '../services/api';
import { getCookie } from '../services/utils';

export const getCities = () => {
    return api.get('/cities-tests').then((res) => res.data.data);
};

export const getPersonalTests = (key: string, { id }: { id: string }) => {
    return api
        .get(getCookie('jid') ? '/available-onsite-tests' : '/onsite-tests', {
            params: {
                'filter[location.city_id]': id,
            },
        })
        .then((response) => response.data.data);
};

export const getPersonalTest = (_: string, { id }: { id: number }) => {
    return api.get(`/onsite-tests/${id}`).then((res) => res.data.data);
};

export const getPersonalTestsPackages = () => {
    return api.get('/onsite-test-packages').then((res) => res.data.data);
};

export const getPersonalTestTerms = (_: string, { id }: { id: string }) => {
    return api.get(`/onsite-test-terms`, {
        params: { lesson_class_id: id },
    }).then((res) => res.data.data);
};
